module.exports = require("babel-runtime/helpers/slicedToArray");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/slicedToArray"
// module id = 17
// module chunks = 0